import styled from "@emotion/styled";
import PropTypes from "prop-types";
import React, { useState } from "react";

import GravityForm from "~/components/GravityForms/GravityForm";

import { ColumnTitle, Copy } from "~/components/Footer/Expert";

import BaseLink from "~/components/links/BaseLink";

import Icon from "~/components/IcoIcon";
import ErrorBoundary from "~/components/ErrorBoundary";

import transition from "~/utilities/transition";

import { useLocationContext } from "~/context/LocationContext";

import {
    ScreenReaderText,
    HiddenSectionHeading,
} from "~/styles/screenReaderText";

const SocialLinks = styled.ul`
    display: flex;
    width: 280px;
    font-weight: 900;
    justify-content: space-between;
`;

const SocialLinksListItem = styled.li``;

const SocialLinksWrapper = styled.nav``;

const StyledBaseLink = styled(BaseLink)`
    ${transition({}, "color")};
    color: ${({ theme }) => theme.palette.white};

    &:hover,
    &:focus {
        color: ${({ theme }) => theme.palette.lightBlue};
    }
`;

const FormError = styled.div`
    color: ${({ theme }) => theme.palette.red};
    font-weight: 900;
    font-size: 1.6rem;
`;

const StayConnected = ({
    title = "",
    pageTitle = "",
    copy = "",
    formId = "",
    socialLinks = [],
    pageTitleInputId = "",
    pageUrlInputId = "",
}) => {
    const [error, setError] = useState("");

    const {
        location: { href },
    } = useLocationContext();

    const onSubmitError = (formData, error) => {
        setError(error[0].message);
    };

    return (
        <>
            {title ? <ColumnTitle>{title}</ColumnTitle> : null}

            {copy ? <Copy>{copy}</Copy> : null}

            {formId ? (
                <ErrorBoundary>
                    <GravityForm
                        id={formId}
                        darkBackground
                        isNewsletter
                        hiddenPresets={[
                            {
                                id: parseInt(pageTitleInputId),
                                value: pageTitle,
                            },
                            {
                                id: parseInt(pageUrlInputId),
                                value: href,
                            },
                        ]}
                        {...{ onSubmitError }}
                    />
                    {error && <FormError>{error}</FormError>}
                </ErrorBoundary>
            ) : null}

            {socialLinks?.length ? (
                <SocialLinksWrapper>
                    <HiddenSectionHeading id="socialLinksLabel">
                        Social Media
                    </HiddenSectionHeading>
                    <SocialLinks aria-labelledby="socialLinksLabel" role="list">
                        {socialLinks.map(
                            ({ icon, linkUrl, screenReaderText }, index) => (
                                <SocialLinksListItem key={`${index}-${icon}`}>
                                    <StyledBaseLink to={linkUrl}>
                                        <Icon {...{ icon }} size={30} />
                                        {screenReaderText ? (
                                            <ScreenReaderText>
                                                {screenReaderText}
                                            </ScreenReaderText>
                                        ) : null}
                                    </StyledBaseLink>
                                </SocialLinksListItem>
                            ),
                        )}
                    </SocialLinks>
                </SocialLinksWrapper>
            ) : null}
        </>
    );
};

StayConnected.propTypes = {
    title: PropTypes.string,
    pageTitle: PropTypes.string.isRequired,
    copy: PropTypes.string,
    formId: PropTypes.string.isRequired,
    pageTitleInputId: PropTypes.string,
    pageUrlInputId: PropTypes.string,
    socialLinks: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.string.isRequired,
            linkUrl: PropTypes.string.isRequired,
            screenReaderText: PropTypes.string,
        }),
    ),
};

export default StayConnected;
